import PlainOption from "../src/plain/PlainOption.js";
export default class ElixOption extends PlainOption {}
customElements.define("elix-option", ElixOption);
